import { render, staticRenderFns } from "./OptometryMeasurements.vue?vue&type=template&id=97a63f6e&scoped=true"
import script from "./OptometryMeasurements.vue?vue&type=script&lang=js"
export * from "./OptometryMeasurements.vue?vue&type=script&lang=js"
import style0 from "./OptometryMeasurements.vue?vue&type=style&index=0&id=97a63f6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a63f6e",
  null
  
)

export default component.exports